exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "blockquote{border-left:5px solid #ccc;padding-left:20px;margin-left:0;font-style:italic;overflow:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /workspace/ckeditor5/node_modules/css-loader?{"minimize":true}!/workspace/ckeditor5/node_modules/sass-loader/lib/loader.js!../ckeditor5-block-quote/theme/theme.scss
// module id = 487
// module chunks = 0